import { PUBLIC_SEGMENTS, type GuidePageKey } from "@/lib/site/publicPages";
import { GUIDES } from "./content";
import type { Guide, GuideKey } from "./types";
import type { LandingLocale } from "@/lib/landing/locale";

export type { Guide, GuideKey } from "./types";

/** Guides in the order the hub, the footer and llms.txt list them. */
export const GUIDE_KEYS: readonly GuideKey[] = [
  "guideAccountants",
  "guidePohoda",
  "guidePohodaHowTo",
  "guideMatching",
  "guideMonthClose",
  "guideFioApi",
  "guideFioToken",
  "guideGpcImport",
  "toolGpcToCsv",
  "toolIsdocViewer",
  "toolQrPayment",
  "toolAccountIban",
  "toolGpcPohoda",
  "guideEmailInbox",
  "guideAccountant",
  "guideSplitPayment",
  "guideIsdoc",
  "guideForeignCurrency",
  "guideMcp",
  "guideVsSpreadsheet",
  "guideFakturoid",
  "guideIdoklad",
];

/** The free tools, in the order the tools hub and llms.txt list them. */
export const FREE_TOOL_KEYS: readonly GuideKey[] = [
  "toolGpcToCsv",
  "toolIsdocViewer",
  "toolQrPayment",
  "toolAccountIban",
  "toolGpcPohoda",
];

export function getGuide(key: GuideKey): Guide {
  return GUIDES[key];
}

/**
 * The page's path in the style `localePath` takes (`/guides`,
 * `/match-payments-with-receipts`): it resolves to the Czech root slug or
 * the English `/en/…` URL for the host.
 */
export function guideNavPath(key: GuidePageKey): string {
  return `/${PUBLIC_SEGMENTS[key]}`;
}

/** "3. 11. 2026" / "3 November 2026", from a YYYY-MM-DD date, without time zones. */
export function formatGuideDate(iso: string, locale: LandingLocale): string {
  const [y, m, d] = iso.split("-").map(Number);
  if (locale === "cs") return `${d}. ${m}. ${y}`;
  const month = new Date(Date.UTC(y, m - 1, 1)).toLocaleString("en-GB", {
    month: "long",
    timeZone: "UTC",
  });
  return `${d} ${month} ${y}`;
}
